export default function products(state = [], action) {
  return state;
}


// WEBPACK FOOTER //
// ./src/redux/products/reducer.js